package com.bikompanion.ui.home

import androidx.compose.foundation.layout.BoxScope
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.Dp
import dev.chrisbanes.haze.HazeState
import com.bikompanion.domain.BikeIssue
import com.bikompanion.domain.BikeNetwork
import com.bikompanion.domain.BikeParkingSpot
import com.bikompanion.domain.BikeStation
import com.bikompanion.domain.BikeType
import com.bikompanion.domain.StationWatch
import com.bikompanion.ui.composables.ParkingDetailsSheet
import com.bikompanion.ui.composables.RateBikeSheet
import com.bikompanion.ui.composables.StationDetailsSheet
import com.bikompanion.ui.models.BikeRatingUiState

@Composable
internal fun BoxScope.HomeSheets(
    selectedStation: BikeStation?,
    selectedParking: BikeParkingSpot?,
    showRatingSheet: Boolean,
    networks: List<BikeNetwork>,
    ratingUiState: BikeRatingUiState,
    watches: List<StationWatch>,
    hazeState: HazeState,
    docked: Boolean,
    dockedWidth: Dp,
    onStationDismiss: () -> Unit,
    onShareStation: (BikeStation) -> Unit,
    onParkingDismiss: () -> Unit,
    onWatch: (BikeStation, BikeType) -> Unit,
    onCancelWatch: (BikeStation, BikeType) -> Unit,
    onRatingBikeNumberChange: (String) -> Unit,
    onRatingElectricToggle: (Boolean) -> Unit,
    onVoteSelect: (Boolean) -> Unit,
    onIssueToggle: (BikeIssue) -> Unit,
    onRatingNetworkSelect: (BikeNetwork) -> Unit,
    onSubmitVoteClick: () -> Unit,
    onRatingDismiss: () -> Unit,
    watchRequiresInstall: Boolean = false,
) {
    StationDetailsSheet(
        station = selectedStation,
        network = networks.firstOrNull { it.id == selectedStation?.networkId },
        hazeState = hazeState,
        onDismiss = onStationDismiss,
        onShareClick = { selectedStation?.let(onShareStation) },
        watches = watches,
        onWatch = onWatch,
        onCancelWatch = onCancelWatch,
        docked = docked,
        dockedWidth = dockedWidth,
        watchRequiresInstall = watchRequiresInstall,
    )

    ParkingDetailsSheet(
        parkingSpot = selectedParking,
        hazeState = hazeState,
        onDismiss = onParkingDismiss,
        docked = docked,
        dockedWidth = dockedWidth,
    )

    RateBikeSheet(
        visible = showRatingSheet,
        uiState = ratingUiState,
        hazeState = hazeState,
        onBikeNumberChange = onRatingBikeNumberChange,
        onElectricToggle = onRatingElectricToggle,
        onVoteSelect = onVoteSelect,
        onIssueToggle = onIssueToggle,
        onNetworkSelect = onRatingNetworkSelect,
        onSubmitClick = onSubmitVoteClick,
        docked = docked,
        dockedWidth = dockedWidth,
        onDismiss = onRatingDismiss,
    )
}
